import React from 'react'
import { AccountSearchState } from '../../types'
import styles from './SearchResultsSummary.module.less'

const SearchResultsSummary = ({
  accountSearchState: {
    accountResults: { length: resultCount },
    searchTerm,
  },
}: {
  accountSearchState: AccountSearchState
}) => {
  return (
    <div className={`${styles.resultsHeader} results-header`}>
      <h4>Search Results</h4>
      <div className={styles.pipe} />
      <span>
        {resultCount > 0
          ? `"${searchTerm}" returned ${resultCount} results`
          : `Your search for "${searchTerm}" returned 0 results`}
      </span>
    </div>
  )
}

export default SearchResultsSummary
